/**
 * OfflineIndicator - Shows network status to users
 * Displays when the user is offline or has poor connectivity
 */

import { useNetworkStatus } from '../../hooks/useNetworkStatus';

export default function OfflineIndicator() {
  const { isOffline, isSlowConnection } = useNetworkStatus();

  if (!isOffline && !isSlowConnection) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center py-2">
          <div className="flex items-center space-x-2">
            <svg
              className="w-5 h-5 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
            <span className="text-sm font-medium text-yellow-800">
              {isOffline 
                ? 'You are currently offline. Some features may not work.'
                : 'Slow connection detected. Some features may be limited.'
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}